import React, { useState, useEffect } from "react";
import { api } from "../utils/api";
import { PageHeader } from "../components/ui/Card";
import { Badge } from "../components/ui/Badge";
import { Button } from "../components/ui/Button";
import { TableCard, td, trStyle } from "../components/ui/Table";
import { EmptyState, LoadingRow } from "../components/ui/EmptyState";
import { colors } from "../components/ui/tokens";

export default function Venues() {
  const [venues, setVenues] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/venues").then(data => {
      if (data && Array.isArray(data.venues)) setVenues(data.venues);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const toggleSuspend = (v: any) => {
    const suspend = v.is_active !== false;
    if (!window.confirm(suspend ? `Suspendre le lieu "${v.name}" ? Il disparaît de la découverte et de sa propre fiche pour tout le monde sauf son propriétaire et l'équipe, jamais supprimé, réactivable à tout moment.` : `Réactiver le lieu "${v.name}" ?`)) return;
    api.put(`/venues/${v.id}/${suspend ? "suspend" : "reactivate"}`, {}).then(data => {
      if (data?.venue) setVenues(prev => prev.map(x => x.id === v.id ? { ...x, is_active: data.venue.is_active } : x));
    }).catch(() => {});
  };

  const toggleVerify = (v: any) => {
    const nextVerified = !v.is_verified;
    api.put(`/venues/${v.id}/verify`, { is_verified: nextVerified }).then(data => {
      if (data?.venue) setVenues(prev => prev.map(x => x.id === v.id ? { ...x, is_verified: data.venue.is_verified } : x));
    }).catch(() => {});
  };

  return (
    <div style={{ padding: 32 }}>
      <PageHeader title="Lieux" subtitle={`${venues.length} lieux`} />

      <TableCard headers={["Lieu", "Type", "Créé par", "Vérifié", "Statut", "Actions"]}>
        {loading ? (
          <tr><td colSpan={6}><LoadingRow /></td></tr>
        ) : venues.length === 0 ? (
          <tr><td colSpan={6}><EmptyState title="Aucun lieu" /></td></tr>
        ) : venues.map(v => (
          <tr key={v.id} style={trStyle}>
            <td style={{ ...td, fontWeight: 600 }}>
              {v.name}
              <div style={{ fontWeight: 400, fontSize: 12, color: colors.textFaint, marginTop: 2 }}>{v.address}</div>
            </td>
            <td style={{ ...td, color: colors.textMuted }}>{v.type || "—"}{v.subtype && v.subtype !== "lieu" ? ` · ${v.subtype}` : ""}</td>
            <td style={{ ...td, color: colors.textMuted }}>
              {v.owner_name || v.created_by_name ? (
                <>
                  <div>{v.owner_name || v.created_by_name}</div>
                  <div style={{ fontSize: 12, color: colors.textFaint }}>{v.owner_email || v.created_by_email}</div>
                </>
              ) : <span style={{ color: colors.textFaint }}>—</span>}
            </td>
            <td style={td}>
              <Button small variant={v.is_verified ? "secondary" : "primary"} onClick={() => toggleVerify(v)}>
                {v.is_verified ? "Dévalider" : "Valider"}
              </Button>
            </td>
            <td style={td}><Badge tone={v.is_active === false ? "danger" : "success"} dot>{v.is_active === false ? "Suspendu" : "Actif"}</Badge></td>
            <td style={td}>
              <Button small variant={v.is_active === false ? "secondary" : "danger"} onClick={() => toggleSuspend(v)}>
                {v.is_active === false ? "Réactiver" : "Suspendre"}
              </Button>
            </td>
          </tr>
        ))}
      </TableCard>
    </div>
  );
}
